export default __webpack_public_path__ + "static/media/about.be4ca753.gif";